import { createStore } from '@qcx/store';
import { useMemo } from 'react';
const initialState = {
    loader: ({ src }) => src,
    loaderPreset: null,
    loaderOptions: null
};
const { Provider, useStore } = createStore(initialState, ({ get }) => ({
    getLoader: () => {
        const { loader, loaderPreset } = get();
        if (loaderPreset) {
            return loaderPresets[loaderPreset];
        }
        return loader;
    }
}));
export const ImageStoreProvider = Provider;
export const useImageStore = useStore;
export const useImageLoader = () => {
    const getLoader = useImageStore(s => s.getLoader);
    const loaderOptions = useImageStore(s => s.loaderOptions);
    return useMemo(() => {
        const loader = getLoader();
        return (props) => loader({ ...props, options: loaderOptions });
    }, [getLoader, loaderOptions]);
};
const normalizeSrc = (src) => src.startsWith('/') ? src.slice(1) : src;
const cloudflareLoader = ({ src, width, quality, blur, options }) => {
    const url = new URL(options.url);
    url.searchParams.append('image', normalizeSrc(src));
    url.searchParams.append('fit', 'scale-down');
    url.searchParams.append('width', width.toString());
    if (quality) {
        url.searchParams.append('quality', quality.toString());
    }
    if (blur) {
        url.searchParams.append('blur', blur.toString());
    }
    return url.toString();
};
const loaderPresets = {
    'cloudflare-image-resizing': cloudflareLoader
};
